var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.00033C11.3333 5.84127 9.84091 7.33366 7.99996 7.33366C6.15901 7.33366 4.66663 5.84127 4.66663 4.00033C4.66663 2.15938 6.15901 0.666992 7.99996 0.666992C9.84091 0.666992 11.3333 2.15938 11.3333 4.00033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5453 9.41662C12.1344 8.94016 11.4286 8.96471 10.8766 9.26681C10.0225 9.73429 9.04231 10.0001 8 10.0001C6.95769 10.0001 5.97745 9.73429 5.12337 9.26681C4.57144 8.96471 3.86561 8.94016 3.45467 9.41662C2.54815 10.4677 2 11.8365 2 13.3334V14.0001C2 14.7364 2.59695 15.3334 3.33333 15.3334H12.6667C13.403 15.3334 14 14.7364 14 14.0001V13.3334C14 11.8365 13.4518 10.4677 12.5453 9.41662Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/IconPerson.61cde403002d0ec0779a8a8b9a85218a.svg";
export { ForwardRef as ReactComponent };